import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';


@Component({
  selector: 'page-odeme-beklenyen-kredi-kartlari',
  templateUrl: 'odeme-beklenyen-kredi-kartlari.html',
})
export class OdemeBeklenyenKrediKartlariPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OdemeBeklenyenKrediKartlariPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/odeme-beklenyen-kredi-kartlari/odeme-beklenyen-kredi-kartlari.ts